import { useBillingInfo } from '@web/account/billing/BillingInfoContext';

export const useBillingInformationSection = () => {
  const { billingInfo } = useBillingInfo();
  let billingAddressLabel: string | null = null;
  if (billingInfo?.billingAddress) {
    const { fullName, city, countryCode, regionCode, line1, postalCode } =
      billingInfo.billingAddress;
    const regionCodeLabel = regionCode ? `${regionCode}, ` : '';

    billingAddressLabel = `${fullName}\n${line1} ${city},\n${regionCodeLabel}${countryCode}, ${postalCode}`;
  }

  return {
    billingAddressLabel,
  };
};
